import React, { Fragment } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

import theme from '../../styles/muiTheme';

const ThemeProvider = ({ children }) => {
    return (
        <Fragment>
            <main>
                <MuiThemeProvider theme={theme}>
                    <StyledComponentsThemeProvider theme={theme}>
                        <StylesProvider injectFirst>{ children }</StylesProvider>
                    </StyledComponentsThemeProvider>
                </MuiThemeProvider>
            </main>
        </Fragment>
    )
}

export default ThemeProvider;